// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  text-align: center;
}
:host ion-textarea {
  background-color: #f00;
  /*border: 2px dashed #fc0;*/
  color: #5D4C44;
  display: inline;
  width: 100%;
  min-width: 100%;
}
:host .customtextarea {
  display: block;
  height: 150px;
  padding: 10px;
  border: 2px solid #fc0;
  background-color: #fff;
  text-align: left;
}
:host textarea.text-input {
  display: block;
  height: 150px;
  margin: 5px;
  padding: 10px;
  border: 2px solid #fc0;
  background-color: #fff;
}
:host .text-input::-moz-placeholder {
  color: #000;
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
